import * as React from "react";
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Stack from "@mui/material/Stack";

export default function Banner({ message, severity }) {
  return (
    <Stack sx={{ width: "100%" }} spacing={2}>
      <Alert icon={false} severity={severity || "success"}>
        {message}
      </Alert>
    </Stack>
  );
}
